module.exports = __webpack_public_path__ + "img/twitter.d079a3bd.svg";